import React, { useState, useEffect } from "react";
import "./App.css"; // optional styling
import axios from "axios";
import { PHPLINK, TESTKEY, LIVEKEY } from "./config";
function App() {
  const [allproducts, setAllproducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [formData, setFormData] = useState({ clientName: "", emailId: "", contactNo: "", city: "", state: "", pincode: "" });
  const [netAmt, setNetAmt] = useState('');
  const [description, setDescription] = useState('');
  const [gst, setGst] = useState('');
  const [pp, setPp] = useState('');
  const [pid, setPid] = useState('');
  const [gstRate, setGstRate] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    setShowPopup(true);
  },
    []);
  const getallproducts = async () => {
    try {
      const response = await axios.get(`${PHPLINK}products.php`, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      if (response.data.msg.msg === 'ok') {
        setAllproducts(response.data.res)
      }

    } catch (error) {

    }
  }
  useEffect(() => {
    getallproducts();
  }, []);
  const handleBuyClick = (product) => {

    if (product.pp === '0') {

      window.open(`https://ganotras.in/${product.pmodel}`, "_blank", "noopener,noreferrer");
      return;
    }
    setSelectedProduct(product);
    const price = Number(product.pp);
    const netAmount = price + (price * 0.18);
    const tax = price * 0.18;
    setNetAmt(netAmount);
    setGst(tax);
    setPp(price);
    setDescription(product.pn);
    setPid(product.pid);
    setGstRate(product.gstRate);
    setShowForm(true);
  };
  const handleChange = (e) => { setFormData({ ...formData, [e.target.name]: e.target.value }); };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { data: OrderData } = await axios.post(`${PHPLINK}createorder.php`,
      { amount: netAmt * 100, currency: "INR" }
    );
    if (OrderData.msg === 'ok') {
      const roptions = {
        // key: `${TESTKEY}`, //FOR TEST KEY
        key: `${LIVEKEY}`, //FOR LIVE KEY
        amount: netAmt * 100,
        currency: 'INR',
        name: 'Ganotras(RedChilly Computers)',
        description: description,
        order_id: OrderData.order_id,
        handler: async function (response) {
          const payload = {
            ...formData,
            razorpay_order_id: response.razorpay_order_id, razorpay_payment_id: response.razorpay_payment_id, razorpay_signature: response.razorpay_signature, gst: gst, description: description, netAmt: netAmt, pp: pp, pid: pid, gstRate: gstRate
          };
          const { data: verifyData } = await axios.post(`${PHPLINK}verify-payment.php`,
            payload,
          );
          if (verifyData.msg === 'ok') {
            alert('Order and Payment Done. Shortly you will receive bill and insallation process information on email.');
            window.location.reload();
          }
        }
      }
      const rzp = new window.Razorpay(roptions);
      rzp.open();
    } else {
      alert('Order Id Not found Try again')
    }
  }
  useEffect(() => { if (showForm) { document.body.classList.add("modal-open"); } else { document.body.classList.remove("modal-open"); } }, [showForm]);
  return (
    <div className="App">
      {/* Hero Section */}
      <div className="col2">
        <div className="col1 icenter fnt30">
          <img src="https://ganotras.in/myimages/rclogo.png" className="cimage" alt="ganotras" />
        </div>
        <div className="col1">
          <header className="hero">
            <h1>RedChilly Computers<sup class="reg">&reg;</sup></h1>
            <p>Your one-stop shop for Computer Hardware, Software & WebApps</p>
            <a href="https://ganotras.in/itsme" target="_blank" rel="noreferrer" className="shop-btn border1blue rounded5 boxshadow">About Owner</a>
          </header>
        </div>
      </div>


      {/* Categories Section */}
      <section className="categories">
        <h1 className="border1blue pad5 rounded5">Our Categories</h1>
        <div className="category-grid">
          <div className="category-card">
            <img src="https://ganotras.in/myimages/comph.jpg" alt="Hardware" />
            <h3>Hardware</h3>
            <p>Latest CPUs, GPUs, RAM, and more.</p>
          </div>
          <div className="category-card">
            <img src="https://ganotras.in/myimages/comps.png" alt="Software" />
            <h3>Software</h3>
            <p>Operating systems, productivity tools, and Cloud Softwares.</p>
          </div>
          <div className="category-card">
            <img src="https://ganotras.in/myimages/compa.jpg" alt="Accessories" />
            <h3>Accessories</h3>
            <p>Keyboards, mice, monitors, and peripherals.</p>
          </div>
        </div>
      </section>

      {/* Featured Products */}
      <section className="featured">
        <h2>Featured Products</h2>
        <div className="bigdiv">
          {allproducts.length > 0 ? (
            allproducts.map((value, index) => (

              <div className="product-grid" key={index}>
                <div className="product-card">
                  <img src={`https://ganotras.in/product-images/${value.imgname}`} alt="Ganotras" />
                  <h3>{value.pn}</h3>
                  <p>{value.product_detail}</p>
                  <p>INR{value.pp}.oo</p>
                  <div className="col5050">
                    <div className="col1 text-center">
                      <button className="btn-buy" onClick={() => handleBuyClick(value)}>Buy Now</button>
                    </div>
                    <div className="col1 text-center">
                      <button className="btn-demo" onClick={() => window.open(`https://ganotras.in/${value.pmodel}`, "_blank", "noopener,noreferrer")}>Demo</button>
                    </div>
                  </div>
                </div>
              </div>

            ))

          )
            : <></>
          }
        </div>
        {showForm && (
          <div className="modal-overlay">
            <div className="modal">
              <form onSubmit={handleSubmit} >
                <div className="col7525">
                  <div className="col1 mt-2 mb-2">
                    <img src="https://ganotras.in/myimages/rclogo.png" className="c60image" alt="ganotras" />
                  </div>
                  <div className="col1">
                    <button className="close" onClick={() => setShowForm(false)}>X</button>
                  </div>
                </div>

                <h2>Purchase {selectedProduct.pn}</h2>
                <div className="col1 mb-2 mt-2">
                  <input type="text" name="clientName" placeholder="Client Name" onChange={handleChange} required pattern="[A-Za-z ]+"
                    title="Only alphabets allowed"
                  />
                </div>
                <div className="col1 mb-2">
                  <input type="email" name="emailId" placeholder="Email ID" onChange={handleChange} required />
                </div>
                <div className="col1 mb-2">
                  <input type="tel" name="contactNo" placeholder="Contact No" onChange={handleChange} required pattern="[0-9]{10}"
                    title="Enter a 10-digit number"
                  />
                </div>
                <div className="col1 mb-2">
                  <input type="text" name="city" placeholder="City" onChange={handleChange} required pattern="[A-Za-z ]+"
                    title="Only alphabets allowed"
                  />
                </div>
                <div className="col1 mb-2">
                  <input type="text" name="state" placeholder="State" onChange={handleChange} required pattern="[A-Za-z ]+"
                    title="Only alphabets allowed"
                  />
                </div>
                <div className="col1 mb-2">
                  <input type="text" name="pincode" placeholder="Pincode" onChange={handleChange} required pattern="[0-9]{6}"
                    title="Enter a 6-digit pincode"
                  />
                </div>
                <p>Item: {selectedProduct.pn}</p>
                <p>Price: INR {selectedProduct.pp}.00</p>
                <p>GST {selectedProduct.gstRate}: INR {selectedProduct.pp * selectedProduct.gstRate / 100}.00</p>

                <p>Net Amount: INR {netAmt}.00</p>

                <button className="btn-purchase" type="submit">Proceed to Pay</button>
              </form>
            </div>
          </div>
        )}
        {showPopup && (
          <div className="popup-overlay" onClick={() => setShowPopup(false)}>
            <div className="popup" onClick={(e) => e.stopPropagation()}>
              <img src="https://ganotras.in/myimages/rclogo.png" alt="Hardware" />
              <h2>Information</h2>
              <p>
                If You Want Customized Software mail us on{" "}
                <a href="mailto:softwares@ganotras.in">softwares@ganotras.in</a>
              </p>
              <button onClick={() => setShowPopup(false)}>X</button>
            </div>
          </div>
        )}
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>&copy; 2008 Ganotras | All Rights Reserved Contact: support@ganotras.in</p>
      </footer>
    </div>
  );
}

export default App;
